module.exports = __webpack_public_path__ + "23ad8043da94fd18a3f410708699520e.svg";